module.exports = __webpack_public_path__ + "img/send.9a7a39a0.png";